// extracted by mini-css-extract-plugin
module.exports = {"iconFavourite":"IconFavourite_iconFavourite__KAIx1","iconFavouritePlus":"IconFavourite_iconFavouritePlus__2x8QK","iconFavouriteWrapper":"IconFavourite_iconFavouriteWrapper__3WzEr"};